import React from 'react';
import { useLoadScript } from '@react-google-maps/api';

const GoogleMapsTest = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBB7eCnq1g88yxps20vrHfiW3QC07G3LPU",
    libraries: ["places"]
  });

  console.log('GoogleMapsTest - isLoaded:', isLoaded);
  console.log('GoogleMapsTest - loadError:', loadError);

  if (loadError) {
    return (
      <div style={{ padding: '20px', backgroundColor: '#fee2e2', borderRadius: '8px', margin: '20px' }}>
        <h3 style={{ color: '#dc2626', margin: '0 0 10px 0' }}>❌ Google Maps API Error</h3>
        <p style={{ color: '#991b1b', margin: '0' }}>
          <strong>Error:</strong> {loadError.message || 'Unknown error'}
        </p>
        <p style={{ color: '#991b1b', margin: '10px 0 0 0' }}>
          <strong>Possible causes:</strong>
        </p>
        <ul style={{ color: '#991b1b', margin: '5px 0 0 20px' }}>
          <li>API key is invalid or expired</li>
          <li>Required APIs are not enabled</li>
          <li>API key restrictions are blocking the request</li>
          <li>Network connectivity issues</li>
        </ul>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div style={{ padding: '20px', backgroundColor: '#fef3c7', borderRadius: '8px', margin: '20px' }}>
        <h3 style={{ color: '#d97706', margin: '0 0 10px 0' }}>⏳ Loading Google Maps API...</h3>
        <p style={{ color: '#92400e', margin: '0' }}>
          Please wait while the Google Maps API loads...
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', backgroundColor: '#d1fae5', borderRadius: '8px', margin: '20px' }}>
      <h3 style={{ color: '#059669', margin: '0 0 10px 0' }}>✅ Google Maps API Loaded Successfully!</h3>
      <p style={{ color: '#065f46', margin: '0' }}>
        The Google Maps API is working correctly with your API key.
      </p>
    </div>
  );
};

export default GoogleMapsTest;
